import { Component } from '@angular/core';
import { dynamicEnvironment } from '../Common/DynamicEnvironment/DynamicEnvironment';

@Component({
  selector: 'app-url-based-reset-password-page',
  templateUrl: './url-based-reset-password-page.component.html'
})
export class UrlBasedResetPasswordPageComponent {

  hospitalURL: boolean = dynamicEnvironment.websiteURL.includes("dev.hospital.nishwik") || dynamicEnvironment.websiteURL.includes("hospital.nishwik");
  
  schoolURL: boolean = dynamicEnvironment.websiteURL.includes("dev.edu.nishwik") || dynamicEnvironment.websiteURL.includes("edu.nishwik");

  societyURL: boolean = dynamicEnvironment.websiteURL.includes("dev.society.nishwik") || dynamicEnvironment.websiteURL.includes("society.nishwik");

  crmURL: boolean = dynamicEnvironment.websiteURL.includes("dev.crm.nishwik") || dynamicEnvironment.websiteURL.includes("crm.nishwik");
}